import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useTheme } from '@mui/material/styles';

import HardwareList from '../../HardwareList';
import RestrictComponent from '../../../../../shared/RestrictComponent';

import { setActiveTab, simpleUpdateCase } from '../../../../../../actions/casesActions';

import { getFileIcon, getFileLabel } from '../../../../../../util/cases';

import { userRoles } from '../../../../../../constants';

const fileTypes = ['preop', 'block'];

const CmfStep3Static = ({ activeCase, goToFiles, userRole, products, updateCase }) => {
  const { files, alignmentData, maxilla, leftMandible, rightMandible, genioplasty } = activeCase;
  const theme = useTheme();

  const classes = {
    primary: {
      color: theme.palette.primary.main,
    },
  };

  const {
    GLOBAL_ADMIN,
    COUNTRY_ADMIN,
    DISTRIBUTOR_ADMIN,
    SURGEON,
    ENGINEER,
    SALES_REP,
    LOGISTICS,
    PRACTICE_MANAGER,
    MANUFACTURER,
  } = userRoles;

  const initialHardwareList = maxilla ? maxilla.map((item) => ({ ...item, id: Math.random() * Math.random() })) : [];
  const initialLeftMandibleList = leftMandible
    ? leftMandible.map((item) => ({ ...item, id: Math.random() * Math.random() }))
    : [];
  const initialRightMandibleList = rightMandible
    ? rightMandible.map((item) => ({ ...item, id: Math.random() * Math.random() }))
    : [];
  const initialGenioplastyList = genioplasty
    ? genioplasty.map((item) => ({ ...item, id: Math.random() * Math.random() }))
    : [];

  const [maxillaList, setMaxillaList] = useState(initialHardwareList);
  const [leftMandibleList, setLeftMandibleList] = useState(initialLeftMandibleList);
  const [rightMandibleList, setRightMandibleList] = useState(initialRightMandibleList);
  const [genioplastyList, setGenioplastyList] = useState(initialGenioplastyList);

  const [isEditMode, setEditMode] = useState(false);
  const [isEditLeftMandibleMode, setEditLeftMandibleMode] = useState(false);
  const [isEditRightMandibleMode, setEditRightMandibleMode] = useState(false);
  const [isEditGenioplastyMode, setEditGenioplastyMode] = useState(false);

  useEffect(() => {
    if (maxilla) {
      setMaxillaList(maxilla.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
    if (leftMandible) {
      setLeftMandibleList(leftMandible.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
    if (rightMandible) {
      setRightMandibleList(rightMandible.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
    if (genioplasty) {
      setGenioplastyList(genioplasty.map((item) => ({ ...item, id: Math.random() * Math.random() })));
    }
  }, [maxilla, leftMandible, rightMandible, genioplasty]);

  const notes = activeCase.notes && activeCase.notes.step5;

  const isPermission = !activeCase.trainingMode
    ? [GLOBAL_ADMIN, COUNTRY_ADMIN]
    : [
      GLOBAL_ADMIN,
      COUNTRY_ADMIN,
      DISTRIBUTOR_ADMIN,
      SURGEON,
      ENGINEER,
      SALES_REP,
      LOGISTICS,
      PRACTICE_MANAGER,
      MANUFACTURER,
    ];

  const onSave = () => {
    const updatedCase = {
      ...activeCase,
      maxilla: maxillaList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
      leftMandible: leftMandibleList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
      rightMandible: rightMandibleList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
      genioplasty: genioplastyList.map((item) => ({
        product: item.product,
        amount: item.amount,
        category: item.category || '',
      })),
    };

    updateCase(updatedCase);
    setEditMode(false);
    setEditLeftMandibleMode(false);
    setEditRightMandibleMode(false);
    setEditGenioplastyMode(false);
  };

  return (
    <div className="case-static-container">
      <div className="m-b-md underline">
        {files
          .filter((file) => fileTypes.includes(file.type))
          .map((item) => (
            <div key={`${item.name}-${item.type}-${item.date}`} className="case-file-list-item" onClick={goToFiles}>
              <div className="width-100">
                <div className="d-flex">
                  <div className="d-flex align-center icon-file-container flex-1">
                    <img src={getFileIcon(item.type)} alt="file-icon" style={{ height: '20px', fill: '#eee' }} />
                    <div className="font-bold">{getFileLabel(item.type)}</div>
                  </div>
                  {item.status && (
                    <div className={`status-indicator status-indicator-file ${item.status}`}>{item.status}</div>
                  )}
                </div>
                <div className="d-flex w-100 space-between m-t-sm">
                  <div className="list-item-title">{item.name}</div>
                </div>
              </div>
            </div>
          ))}
      </div>

      <div className="p-b-md m-b-md underline">
        <div className="m-b-sm d-flex">
          <div className="secondary">MAXILLA</div>
          <RestrictComponent roles={isPermission}>
            {isEditMode ? (
              <div className={`${classes.primary} m-l-sm pointer`} style={{ color: theme.palette.primary.main }} onClick={onSave}>
                Save
              </div>
            ) : (
              <div className={`${classes.primary} m-l-sm pointer`} style={{ color: theme.palette.primary.main }} onClick={() => setEditMode(true)}>
                Edit
              </div>
            )}
          </RestrictComponent>
        </div>

        {isEditMode ? (
          <HardwareList
            classes={classes}
            hardwareList={maxillaList}
            products={products}
            onAdd={() => {}}
            onRemove={() => {}}
            onAmountChange={() => {}}
            onCategoryChange={() => {}}
            onChange={() => {}}
            procedureFlow={activeCase.procedureFlow}
          />
        ) : (
          maxillaList.map((item, index) => (
            <div key={`${index}-${item.product}`} className="d-flex">
              <div>
                {`${index + 1}.`} <span className="secondary">{item.category}</span> {item.product}
              </div>
              <div className="secondary m-l-sm">x {item.amount}</div>
            </div>
          ))
        )}
      </div>

      {notes && (
        <div className="m-t-md p-t-sm border-top">
          <div className="secondary">Notes:</div>
          <div>{notes}</div>
        </div>
      )}
    </div>
  );
};

CmfStep3Static.propTypes = {
  activeCase: PropTypes.object,
  goToFiles: PropTypes.func,
};

const mapStateToProps = (state) => {
  const activeCase = state.cases.activeCase;
  const procedure = state.procedures.list.find((procedure) => procedure.id === activeCase.procedure);
  const products = procedure ? procedure.products : [];

  return {
    activeCase,
    products,
    userRole: state.user.currentUser.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToFiles: () => dispatch(setActiveTab(2)),
    updateCase: (updatedCase) => dispatch(simpleUpdateCase(updatedCase)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CmfStep3Static);
